import React__default from 'react';
import { TouchableOpacity, View, Image, StyleSheet, FlatList } from 'react-native';
import { u as useTheme } from './useTheme-90e8e2c2.esm.js';
import { A as AppInputLabel } from './index-5ae71f5a.esm.js';
import { useTranslation } from 'react-i18next';
import { a as AppIcon, A as AppText } from './index-6b88191c.esm.js';

const generateBackgroundColor = (isSelected, isDisabled) => {
  return isSelected ? isDisabled ? "start_base_button_colour_opaque" : "primary" : isDisabled ? "darkGrey" : "lightGrey";
};
var Common = {
  generateBackgroundColor
};

function AppMultipleSelectionItem(_ref) {
  var _currentTheme$theme, _currentTheme$theme2, _currentTheme$theme3, _currentTheme$theme4;
  let {
    item,
    imageProperty,
    imageSource,
    titleProperty,
    optionsWidth,
    optionsHeight,
    descriptionProperty,
    onSelectItem,
    isSelected,
    isImageDisplayed,
    disabled,
    style,
    isElevated
  } = _ref;
  const {
    currentTheme
  } = useTheme();
  const styles = generateStyles$1(currentTheme, isElevated);
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React__default.createElement(TouchableOpacity, {
    onPress: () => {
      onSelectItem(item);
    },
    disabled: disabled,
    style: [styles.optionContainer, {
      backgroundColor: currentTheme === null || currentTheme === void 0 ? void 0 : currentTheme.theme[Common.generateBackgroundColor(isSelected, disabled)],
      width: optionsWidth,
      height: optionsHeight
    }, style]
  }, /*#__PURE__*/React__default.createElement(View, null, /*#__PURE__*/React__default.createElement(View, {
    style: styles.optionContainerTopRow
  }, imageSource && isImageDisplayed ? /*#__PURE__*/React__default.createElement(Image, {
    souce: imageSource,
    style: styles.cardIcon
  }) : isImageDisplayed && /*#__PURE__*/React__default.createElement(AppIcon, {
    style: styles.cardIcon,
    size: 50,
    name: item[imageProperty]
  }), /*#__PURE__*/React__default.createElement(AppText, {
    size: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.medium_font_size,
    fontWeight: "bold",
    color: isSelected ? currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme2 = currentTheme.theme) === null || _currentTheme$theme2 === void 0 ? void 0 : _currentTheme$theme2.white : currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme3 = currentTheme.theme) === null || _currentTheme$theme3 === void 0 ? void 0 : _currentTheme$theme3.font_color,
    wrapperStyle: styles.cardTitle
  }, t(item[titleProperty])), item[descriptionProperty] && /*#__PURE__*/React__default.createElement(AppText, {
    size: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme4 = currentTheme.theme) === null || _currentTheme$theme4 === void 0 ? void 0 : _currentTheme$theme4.medium_font_size,
    style: styles.cardDescription
  }, t(item[descriptionProperty])))));
}
const generateStyles$1 = (props, isElevated) => {
  var _props$theme, _props$theme2;
  return StyleSheet.create({
    optionContainerTopRow: {
      flex: 1,
      width: "100%",
      flexDirection: "column",
      justifyContent: "space-between",
      padding: 15
    },
    cardDescription: {
      // alignSelf: "flex-start",
      paddingTop: 10
    },
    cardTitle: {
      justifyContent: "center"
    },
    descriptionContainer: {
      // justifyContent: "flex-start",
    },
    bottomIcon: {
      alignSelf: "center",
      paddingTop: 10
    },
    cardIcon: {
      flex: 0.3,
      backgroundColor: "red"
    },
    optionContainer: {
      // flex: 0.7,
      // height: 160,
      // width: 150,
      flexDirection: "column",
      // flexWrap: "wrap",
      justifyContent: "space-between",
      // alignItems: "flex-start",

      borderColor: "transparent",
      borderRadius: 10,
      borderWidth: 1,
      shadowOpacity: 0.3,
      shadowRadius: 4.84,
      shadowColor: isElevated ? props === null || props === void 0 ? void 0 : (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.shadowColor : props === null || props === void 0 ? void 0 : (_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : _props$theme2.transparent,
      shadowOffset: {
        width: 3,
        height: 3
      }
      // borderColor: "transparent",
    }
  });
};
AppMultipleSelectionItem.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppMultipleSelectionItem"
};

function AppMultipleSelection(_ref) {
  let {
    onSelectItem,
    selectedItem,
    optionsWidth,
    optionsHeight,
    titleProperty = "title",
    imageProperty = "image",
    imageSource,
    descriptionProperty = "description",
    optionKey = "id",
    numberOfColumns = 2,
    height = "auto",
    width,
    OptionItem = AppMultipleSelectionItem,
    options,
    showTextInputLabel,
    isMandatory,
    label,
    optionItemStyle,
    disabled,
    style,
    isElevated = true,
    containerStyle
  } = _ref;
  useTheme();
  const styles = generateStyles();
  const _columnWrapperStyle = numberOfColumns > 1 ? {
    justifyContent: "space-between"
  } : null;
  return /*#__PURE__*/React__default.createElement(View, {
    style: style
  }, showTextInputLabel ? /*#__PURE__*/React__default.createElement(AppInputLabel, {
    style: {
      marginLeft: 0
    },
    isMandatory: isMandatory,
    label: label
  }) : null, /*#__PURE__*/React__default.createElement(TouchableOpacity, null, /*#__PURE__*/React__default.createElement(View, {
    style: [styles.container, {
      height: height,
      width: width
      // backgroundColor: "brown",
      // backgroundColor:
      //   backgroundColor || currentTheme?.theme?.backgroundColor,
    }, containerStyle]
  }, /*#__PURE__*/React__default.createElement(FlatList, {
    style: {
      width: "100%",
      paddingVertical: 10,
      paddingHorizontal: 5,
      backgroundColor: "transparent"
    },
    bounces: false,
    numColumns: numberOfColumns,
    data: options,
    keyExtractor: item => item[optionKey].toString(),
    columnWrapperStyle: _columnWrapperStyle,
    renderItem: _ref2 => {
      let {
        item
      } = _ref2;
      return (
        /*#__PURE__*/
        // <Text>{opt?.type}</Text>
        React__default.createElement(OptionItem, {
          disabled: disabled || (item === null || item === void 0 ? void 0 : item.disabled),
          isElevated: isElevated,
          optionsWidth: optionsWidth,
          optionsHeight: optionsHeight,
          isImageDisplayed: false,
          isSelected: selectedItem == item[optionKey],
          onSelectItem: onSelectItem,
          key: item[optionKey],
          item: item,
          imageProperty: imageProperty,
          imageSource: imageSource,
          titleProperty: titleProperty,
          descriptionProperty: descriptionProperty,
          style: optionItemStyle
        })
      );
    }
  }))));
}
const generateStyles = props => {
  return StyleSheet.create({
    container: {
      flexDirection: "column",
      justifyContent: "space-between",
      borderRadius: 0,
      alignItems: "center",
      alignContent: "center"
      // flex: 1,
    }
  });
};
AppMultipleSelection.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppMultipleSelection",
  "props": {
    "titleProperty": {
      "defaultValue": {
        "value": "\"title\"",
        "computed": false
      },
      "required": false
    },
    "imageProperty": {
      "defaultValue": {
        "value": "\"image\"",
        "computed": false
      },
      "required": false
    },
    "descriptionProperty": {
      "defaultValue": {
        "value": "\"description\"",
        "computed": false
      },
      "required": false
    },
    "optionKey": {
      "defaultValue": {
        "value": "\"id\"",
        "computed": false
      },
      "required": false
    },
    "numberOfColumns": {
      "defaultValue": {
        "value": "2",
        "computed": false
      },
      "required": false
    },
    "height": {
      "defaultValue": {
        "value": "\"auto\"",
        "computed": false
      },
      "required": false
    },
    "OptionItem": {
      "defaultValue": {
        "value": "AppMultipleSelectionItem",
        "computed": true
      },
      "required": false
    },
    "isElevated": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    }
  }
};

// Code used to leverage third party libraries
// {props.isOptionWithIcon ? (
//   <View style={styles.listIconsContainer}>
//     {props.options.map((item) => {
//       return (
//         <AppIcon

//           background={item.background}
//           name={item.icon}
//           label={item.label}
//           onPress={() => {
//             onPress(item);
//           }}
//         />
//       );
//     })}
//   </View>
// ) : (
//   <FlatList
//     data={props.options}
//     keyExtractor={(item) => item.label}
//     renderItem={({ item }) => {
//       return (
//         <AppPickerItem
//           item={item}
//           onPress={() => {
//             onPress(item);
//           }}
//         />
//       );
//     }}
//   />
// )}

export { AppMultipleSelection as A, Common as C, AppMultipleSelectionItem as a };
